import { Link } from "react-router-dom";


type cardServicesProps = {
    nomeService: string;
    link: string;
    disabled?: boolean;
}
export default function CardOpcoes({ nomeService, link, disabled = false }: cardServicesProps) {
    const cardClasses = `tw-flex tw-h-full tw-min-h-[110px] tw-w-full tw-items-center tw-justify-center tw-rounded-2xl tw-border tw-border-[#a04ae2] tw-bg-white tw-p-5 tw-text-center tw-shadow-sm tw-transition-all tw-duration-200 tw-ease-in-out hover:tw-bg-[#f8f4ff] hover:tw-shadow-md ${disabled ? 'tw-pointer-events-none tw-opacity-50' : 'tw-opacity-100'}`

    const cardContent = (
        <div className={cardClasses} aria-disabled={disabled}>
            <div className="tw-flex tw-flex-col tw-items-center tw-gap-2">
                <p className="tw-text-sm tw-font-semibold tw-uppercase tw-tracking-wide tw-text-black sm:tw-text-base">
                    {nomeService}
                </p>
            </div>
        </div>
    )

    return disabled ? (
        cardContent
    ) : (
        <Link
            to={link}
            className="tw-no-underline focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#a04ae2] focus-visible:tw-ring-offset-2"
            aria-label={nomeService}
        >
            {cardContent}
        </Link>
    )
}
